import React, { useState, useEffect, useRef } from 'react'
import ReactDOM from 'react-dom'
import {
  ActionButtonsStyle,
  POListSettingsFormStyle,
  DataFillFormStyle,
  RecordsPerPageFormStyle } from './css/POListSettingsFormStyle'

function DateFilterForm(props) {
  const [date, setDate] = props.date
  const { app } = props
  const dateCreatedFetchAllBtnRef = useRef(null)
  const defaultDate = {
    from: (new Date(app.getClientDateTime()).getFullYear() + '-01'),
    to: (new Date(app.getClientDateTime()).getFullYear() + '-12')
  }

  useEffect(() => {
    dateCreatedFetchAllBtnRef.current.focus()
  }, [])

  const onChangeDateCreatedCheck = (e) => {
    const fetch_all = date.date_created_fetch_all
    setDate({
      ...date,
      date_created_from: fetch_all ? defaultDate.from : '',
      date_created_to: fetch_all ? defaultDate.to : '',
      date_created_fetch_all: (!fetch_all)
    })
  }

  const onChangeDatePreparedCheck = (e) => {
    const fetch_all = date.date_prepared_fetch_all
    setDate({
      ...date,
      date_prepared_from: fetch_all ? defaultDate.from : '',
      date_prepared_to: fetch_all ? defaultDate.to : '',
      date_prepared_fetch_all: (!fetch_all)
    })
  }

  return (
    <React.Fragment>
      <div id='dates' className='form-container'>
        <h4 className='header-caption'>Filter date range</h4>
        <div style={{fontSize: '0.7em', margin: '10px 0', paddingLeft: '10px'}}>
          <p> Will only fetch the data within these ranges of date.</p>
        </div>
        <div id='date-filter-form-container'>

          {/********** DATE CREATED ***********/}
          <div className='date-filter-form'>
            <label>Date Created</label>
            <hr/>
            <div className='date-field-form-container'>
              <div
                id='date-created-fetch-all-container'
                className="checkbox-fetch-all-container">
                <input
                  ref={dateCreatedFetchAllBtnRef}
                  className='top-anchor'
                  id="date-created-checkbox-fetch-all"
                  checked={date.date_created_fetch_all}
                  onChange={onChangeDateCreatedCheck}
                  type="checkbox"
                />
                {' '}
                <button
                  type="button"
                  className='fetch-all-btn'
                  onClick={onChangeDateCreatedCheck}
                  id="date-created-fetch-all-btn">
                  Fetch all
                </button>
              </div>
              <div className='date-from'>
                <label>From</label>
                <input
                  disabled={date.date_created_fetch_all}
                  value={date.date_created_from || ''}
                  onChange={(e) => {
                    setDate({ ...date, date_created_from: e.target.value })
                  }}
                  type='month'
                />
              </div>
              <div className='date-to'>
                <label>To</label>
                <input
                  disabled={date.date_created_fetch_all}
                  value={date.date_created_to || ''}
                  onChange={(e) => {
                    setDate({ ...date, date_created_to: e.target.value })
                  }}
                  type='month'
                />
              </div>
            </div>
          </div>

          <br/>

          {/********** DATE PREPARED ***********/}
          <div className='date-filter-form'>
            <label>Date Prepared</label>
            <hr/>
            <div className='date-field-form-container'>
              <div
                id='date-prepared-fetch-all-container'
                className="checkbox-fetch-all-container">
                <input
                  id="date-prepared-checkbox-fetch-all"
                  checked={date.date_prepared_fetch_all}
                  onChange={onChangeDatePreparedCheck}
                  type="checkbox"
                />
                {' '}
                <button
                  type="button"
                  className='fetch-all-btn'
                  onClick={onChangeDatePreparedCheck}
                  id="date-prepared-fetch-all-btn">
                  Fetch all
                </button>
              </div>
              <div className='date-from'>
                <label>From</label>
                <input
                  disabled={date.date_prepared_fetch_all}
                  value={date.date_prepared_from || ''}
                  onChange={(e) => {
                    setDate({ ...date, date_prepared_from: e.target.value })
                  }}
                  type='month'
                />
              </div>
              <div className='date-to'>
                <label>To</label>
                <input
                  disabled={date.date_prepared_fetch_all}
                  value={date.date_prepared_to || ''}
                  onChange={(e) => {
                    setDate({ ...date, date_prepared_to: e.target.value })
                  }}
                  type='month'
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <DataFillFormStyle />
    </React.Fragment>
  )
}

function RecordsPerPageForm(props) {
  const [footer, setFooter] = props.footer

  const onChange = (e) => {
    if (e.target.value) setFooter({ record_per_page: parseInt(e.target.value) })
    else setFooter({ record_per_page: e.target.value })
  }

  return (
    <React.Fragment>
      <div id='rpp' className='form-container'>
        <h4 className='header-caption'>Records/Page</h4>
        <div id='rpp-form'>
          <label>Records/Page</label>
          <input
            type='number'
            value={footer.record_per_page}
            onChange={onChange}
          />
        </div>
      </div>
      <RecordsPerPageFormStyle />
    </React.Fragment>
  )
}

function ActionButtons(props) {
  const updatePOSettings = props.updatePOSettings

  return (
    <React.Fragment>
      <div id='buttons' className='form-container'>
        <div id='action-button-container'>
          <button
            onClick={(e) => {
                updatePOSettings()
                ReactDOM.unmountComponentAtNode(document.getElementById('modal-form-container'))
              }}
            className='pospro-action-btn'>
            Apply
          </button>
          <button
            onClick={(e) => {
                ReactDOM.unmountComponentAtNode(document.getElementById('modal-form-container'))
              }}
            className='pospro-action-btn bottom-anchor'>
            Close
          </button>
        </div>
      </div>
      <ActionButtonsStyle />
    </React.Fragment>
  )
}

function usePOListSettingsForm(props) {
  const app = props.app
  const { poListController } = props
  const [poSettings, setPOSettings] = poListController.poSettings
  const [date, setDate] = useState({ ...poSettings.date })
  const [footer, setFooter] = useState({ ...poSettings.footer })

  const obj = {
    poSettings: [poSettings, setPOSettings],
    date: [date, setDate],
    footer: [footer, setFooter],
    updatePOSettings: async () => {
      await poListController.savePOSettings(app, { date, footer })
      setPOSettings({date, footer})
    }
  }

  return obj
}

function POListSettingsForm(props) {
  const poListSettingsForm = usePOListSettingsForm(props)
  return (
    <React.Fragment>
      <div id='main-container'>
        <div className='content-wrapper'>
          <DateFilterForm app={props.app} date={poListSettingsForm.date} />
          <RecordsPerPageForm footer={poListSettingsForm.footer} />
        </div>
        <ActionButtons updatePOSettings={poListSettingsForm.updatePOSettings} />
      </div>
      <POListSettingsFormStyle />
    </React.Fragment>
  )
}

export default React.memo(POListSettingsForm)